import { Component, ElementRef, Input, NgZone, OnInit, ViewChild, ChangeDetectorRef, Renderer2 } from '@angular/core';
import { EdizioneObj } from '../../classes/edizione-obj';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '../base/base.component';
import { ActivatedRoute, Router } from '@angular/router';
import { directus, Edizione, Iscrizione, Progetto } from '../../../../directus';
import { readItem, updateItem } from '@directus/sdk';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IscrizioneObj } from '../../classes/iscrizione-obj';
import { AppComponent } from '../../app.component';
import { AutoFocus } from '../../directives/autofocus.directive';

@Component({
  selector: 'app-presenze-multiple',
  standalone: true,
  imports: [CommonModule, FormsModule, FontAwesomeModule, AutoFocus],
  templateUrl: './presenze-multiple.component.html',
  styleUrl: './presenze-multiple.component.css'
})
export class PresenzeMultipleComponent extends BaseComponent implements OnInit {
  edizione: EdizioneObj | undefined;
  progetto: Progetto | undefined;

  faCheck: any;
  @Input() _insertId?: string;
  @ViewChild("input") input?: ElementRef;

  @ViewChild('divRegistrati') divRegistrati?: ElementRef;

  constructor(router: Router, private route: ActivatedRoute, public zone: NgZone, private chRef: ChangeDetectorRef, private renderer: Renderer2, private _app: AppComponent) {
    super(router);

    this.faCheck = faCheck;
  }
  async ngOnInit(): Promise<void> {
    if (this.route.snapshot.paramMap.get('id')) {
      const _id = this.route.snapshot.paramMap.get('id');
      if (_id) {
        const __id = _id as unknown as number;
        await this.getEdizioneById(__id);
        if (this.edizione && this.edizione != undefined) {
          const _idEd = Number(this.edizione.id);
          await this.getProgettoById(this.edizione.progetto);
          if (this.progetto?.colore) {
            this._bgColor = this.getBackgroundAlpha(this.progetto?.colore);
          }
        }
      } else {
        alert(' Edizione non trovata!');
      }
    }
  }
  /*ISCRITTO*/
  async getIscrizioneById(id: number) {
    return directus
      .request<IscrizioneObj>(readItem('iscrizioni', id));
  }

  /*PRESENZA*/
  async registra(value: any) {
    try {
      if (!this._insertId || !this._insertId == undefined || this._insertId.length <= 0)
        return;

      let self = this;

      const _subs = this._insertId.split(/\r?\n/);

      self._app.showSpinner();

      _subs.forEach(async (_i: string) => {
        //alert(_i);
        let _str = _i;

        var n = 0;
        if (_str != undefined) {
          n = _str.lastIndexOf('/');
          _str = _str.substring(n + 1);
          //alert(_str);
        }
        if (this._insertId != undefined && n <= 0) {
          n = _str.lastIndexOf('-');
          _str = _str.substring(n + 1);
          //alert(_str);
        }

        let _id = Number(_str);
        //alert('id' + ' ' + _id);

        if (!_id && _id == undefined || Number.isNaN(_id) || _id <= 0)
          return;

        const result = await directus
          .request<Iscrizione>(updateItem('iscrizioni', _id, { presenza: 1 }));
        self.addElement(new IscrizioneObj(result));
        self.chRef.detectChanges();
      });
      self._app.hideSpinner();
      this._insertId = '';
      //this.input?.nativeElement.focus();
    } catch (error) {
      console.log(error);
    }
  };
  public trackItem(index: number, item: IscrizioneObj) {
    return item.id;
  }
  addElement(_sub: IscrizioneObj) {
    const _txt = _sub.nome + " " + _sub.cognome;

    const p: HTMLParagraphElement = this.renderer.createElement('p');

    p.innerHTML = `          <p class="ml-12 my-5">
        <span>${_txt}</span> <span style="font-weight: bold;"> -> registrato</span>
      </p>`;
    this.renderer.appendChild(this.divRegistrati?.nativeElement, p);

    /*
      */
  }
  /*
  PROGETTO
  */
  async getProgettoById(id: number) {
    try {
      this.progetto = await directus
        .request<Progetto>(readItem('progetti', id));
    } catch (error) {
      console.log(error);
    }
  }
  /*
  EDIZIONE
  */
  async getEdizioneById(id: number) {
    const _ed: Edizione = await directus
      .request<Edizione>(readItem('edizione', id));

    this.edizione = new EdizioneObj(_ed);
  }

}
